/**
 * Fonction pour gérer la suppression d'un edge dans le diagramme CallFlow
 * Nettoie également les données dans callFlowData
 */
export const createHandleEdgeDelete = (
  setEdges,
  setCallFlowData,
  callFlowData,
  previousCallFlowDataRef,
  saveCallFlowToDatabase
) => {
  return (edgeId) => {
    
    // Obtenir les edges actuels pour trouver celui à supprimer
    setEdges((currentEdges) => {
      const edgeToDelete = currentEdges.find(e => e.id === edgeId);
      
      
      if (!edgeToDelete) {
        return currentEdges.filter(e => e.id !== edgeId);
      }
      
      // Supprimer l'edge du callFlowData si nécessaire
      if (edgeToDelete.source?.startsWith('routing-')) {
        const routingKey = edgeToDelete.source.replace('routing-', '');
        const routing = callFlowData?.routing?.[routingKey];
        const edgeLabel = edgeToDelete.label;
        
        if (routing) {
          setCallFlowData(prev => {
            const updated = { ...prev };
            const updatedRouting = { ...updated.routing[routingKey] };
            
            if (routing.type === 'ivr' || routing.type === 'IVR') {
              // Supprimer l'option IVR par DTMF
              if (edgeLabel && updatedRouting.options?.[edgeLabel]) {
                const options = { ...updatedRouting.options };
                delete options[edgeLabel];
                updatedRouting.options = options;
              }
            } else if (routing.type === 'prompt') {
              // Supprimer le next du Prompt
              if (updatedRouting.next) {
                delete updatedRouting.next;
              }
            } else if (routing.type === 'check_variable' || routing.type === 'time' || routing.type === 'check_days' || routing.type === 'regexp') {
              // Supprimer onMatched ou onUnMatched
              if (edgeLabel === 'match' && updatedRouting.onMatched) {
                delete updatedRouting.onMatched;
              } else if (edgeLabel === 'unmatch' && updatedRouting.onUnMatched) {
                delete updatedRouting.onUnMatched;
              }
            }
            
            updated.routing = {
              ...updated.routing,
              [routingKey]: updatedRouting
            };
            
            // Réinitialiser la référence pour forcer la régénération du diagramme
            previousCallFlowDataRef.current = null;
            
            
            // Sauvegarder dans la base de données
            saveCallFlowToDatabase(updated)
              .then(() => {
              })
              .catch((error) => {
                console.error('❌ Error saving edge deletion:', error);
              });
            
            return updated;
          });
        }
      }
      
      // Retourner les edges sans celui qui a été supprimé
      return currentEdges.filter(e => e.id !== edgeId);
    });
  };
};
